export default __webpack_public_path__ + "static/media/category.dccb44a9.svg";